export default function MySQL_DAY() {
  return (
    <div>
      <h2>MySQL_DAY</h2>    </div>
  );
}